exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active-filters[data-v-d469b060]{margin:30px 0}.active-filters__container[data-v-d469b060]{display:flex;flex-wrap:wrap;gap:8px;align-items:center;max-width:1080px;margin:0 auto}.active-filters__container[data-v-d469b060] .filter-pill{margin-right:0;margin-bottom:0}@media (max-width:768px){.active-filters[data-v-d469b060]{margin-bottom:16px;padding:0 20px}.active-filters__container[data-v-d469b060]{gap:6px}}", ""]);

// exports
